import React from 'react';

import * as S from './TopSection.styles';
import Header from './Header/Header';
import LoginGrow from './LoginGrow/LoginGrow';

const TopSection = ({displayPop, timeZone, showBackButton, width, lob}) => {
  return (
    <S.TopSectionMainWrap>
      <S.TopSectionInnerWrap>
        <Header timeZone={timeZone} />
        <LoginGrow displayPop={displayPop} timeZone={timeZone} lob={lob} width={width} />
      </S.TopSectionInnerWrap>
    </S.TopSectionMainWrap>
  );
};

export default TopSection;
